export default __webpack_public_path__ + "static/media/icon_react1.63bacf65.png";